import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        labelRulePage: {
            component: 'Viewport',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/labelRule',
                            component: 'labelRulePage',
                            breadcrumbName: '核心标签规则管理',
                            childRoutes: [
                                {
                                    path: '/update/:id',
                                    component: 'labelRuleAddView',
                                    breadcrumbName: '标签规则修改',
                                },
                                {
                                    path: '/detail/:id',
                                    component: 'labelRuleAddView',
                                    breadcrumbName: '标签规则详情',
                                },
                                {
                                    path: '/add',
                                    component: 'labelRuleAddView',
                                    breadcrumbName: '新增标签规则',
                                },
                                {
                                    path: '/',
                                    component: 'labelRuleListView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
